import { IconButton } from '@cian/ui-kit/button';
import { IconActionCompareAdd16, IconActionCompareAdded16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface INewbuildingComparisonIconButtonProps {
  isAdded: boolean;
  onClick(event: React.MouseEvent<HTMLButtonElement>): void;
}

export const NewbuildingComparisonIconButton: React.FC<INewbuildingComparisonIconButtonProps> = ({
  isAdded,
  onClick,
}) => {
  const Icon = isAdded ? IconActionCompareAdded16 : IconActionCompareAdd16;
  const testId = isAdded ? 'RemoveFromComparisonButton' : 'AddToComparisonButton';

  return (
    <IconButton
      icon={<Icon color="icon-inverted-default" />}
      onClick={onClick}
      aria-label={isAdded ? 'Удалить из сравнения' : 'Добавить к сравнению'}
      data-name={testId}
      data-testid={testId}
    />
  );
};
